// extracted by mini-css-extract-plugin
export default {"prob":"prob-qr4vSmQe"};